import gsap, { Power2, Sine, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


// Add Class When Scrolled To Screen.
// Usage: add class js-add-class-when-in-screen,
//    add attribute: data-add-class="className",
//    to add each time when scrolled add attribute: add-class-repeat
document.querySelectorAll('.js-add-class-when-in-screen').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom-=30px", // el top, screen bottom
    once: el.getAttribute('add-class-repeat'),
    onEnter: () => {
      let addClass = el.getAttribute('data-add-class') ? el.getAttribute('data-add-class') : 'js-in-screen';
      el.classList.add(addClass)
    }
  });
})


// draw line hr
document.querySelectorAll('hr, .user-content h2').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom", // el top, screen bottom
    once: true,
    markers: false,
    onEnter: () => {
      let addClass = 'in-screen'
      el.classList.add(addClass)
    }
  });
})

// draw line for blocquote
document.querySelectorAll('blockquote').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom-=30px", // el top, screen bottom
    once: true,
    onEnter: () => {
      let addClass = 'in-screen'
      el.classList.add(addClass)
    }
  });
})



// fade in when in screen
let fadeInArr = [...$('.js-fade-when-in-screen')]
$.each(fadeInArr, function(){

  ScrollTrigger.create({
    trigger: this,
    start: "top bottom+=50px", // el top, screen bottom
    once: true,
    onEnter: () => {
      gsap.to(this, { y: 0, opacity: 1, delay: 0.1, duration: 0.6, ease: Sine.easeIn })
    }
  });

})

let fadeInArr2 = [...$('.js-fade-when-in-screen-2')]
$.each(fadeInArr2, function(){

  ScrollTrigger.create({
    trigger: this,
    start: "top bottom+=50px", // el top, screen bottom
    once: true,
    onEnter: () => {
      gsap.to(this, { y: 0, opacity: 1, delay: 0.5, duration: 0.4, ease: Sine.easeIn })
    }
  });

})